//Node imports
import { IWinLineObject, SlotConstants, SlotEventConstants } from "@quest/slot-core";
import { delayedCall, dispatcher, IEvent, ingenuity, IObject, killDelayedCall } from "@quest/base-core";
import { WinPresentationPanel, SlotConstantsBehavior, SlotEventConstantsBehavior, AudioControllerBehavior } from "@quest/murka-games-behavior-leopard/dist";

//Game modules
import { GameParserModel } from "../Platform/GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { gameConstants } from "../Constants/gameConstants";
// import { SoundConstantGame } from "../Constants/SoundConstantGame";
// import { gameConstants } from "../Constants/gameConstants";

/**
 * WinPresentationControllerGame class handels the winpresentation for base game.
 * it controls the win frames, symbol animation presentation.
 */
export class WinPresentationPanelGame extends WinPresentationPanel {
  private playCount: number = 0;

    public  subscribeEvents(): void{
      super.subscribeEvents()
      dispatcher.on(eventDispatchers.RESET_TOGGLE_SOUND_COUNTER,this.resetPlaySoundCounter,this)
    };
    public  unsubscribeEvents(): void{
      super.unsubscribeEvents()
      dispatcher.off(eventDispatchers.RESET_TOGGLE_SOUND_COUNTER,this.resetPlaySoundCounter,this)
    };
  /**
   * Method playScatterWinAnimations overided to update functionality to reduce delay time
   */
  protected playScatterWinAnimations(evt: any): void {
    const scatterWinData: IObject = evt.data;
    const tickUpCompleteDelayTime: number = 100;
    let i: number;
    let j: number;
    let symbolID: number;
    if (!(ingenuity.parserModel as GameParserModel).getRetriggerFreeSpins()) {
      !ingenuity.currentGame.state.getCurrentState().model.getIsAutoPlayLeft() && dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_SCATTER_WIN_MSSG, (ingenuity.parserModel as GameParserModel).getTriggerScatterWinData());
    }
    if (ingenuity.configData.animationStopInScatterwin) {
      this.stopAllWinAnimations();
    }
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      dispatcher.fireEvent(SlotEventConstants.FG_SCATTER_ANIMATION_STARTED, scatterWinData);
    }
    else {
      dispatcher.fireEvent(SlotEventConstants.SCATTER_ANIMATION_STARTED, scatterWinData);
    }
    for (i = 0; i < scatterWinData.length; i++) {
      for (j = 0; j < scatterWinData[i].positions.length; j++) {
        symbolID = this.model.getReelGridElement(scatterWinData[i].positions[j][0], scatterWinData[i].positions[j][1]);
        this.playSymbolTriggerAnimationByID(symbolID, scatterWinData[i].positions[j][0], scatterWinData[i].positions[j][1], "triggering");
      }
    }
    delayedCall(SlotConstants.TimerScatterAnimationEnded, SlotConstantsBehavior.TIME_SCATTER_ANIMATION_END, () => {
      killDelayedCall(SlotConstants.TimerScatterAnimationEnded);
      if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
        dispatcher.fireEvent(SlotEventConstants.FG_SCATTER_ANIMATION_ENDED, scatterWinData);
      }
      else {
        /**
         * delay used if there is a scatter win without line win, for tickup to complete
         */
        delayedCall("TickUpComplete", tickUpCompleteDelayTime, () => {
          killDelayedCall("TickUpComplete");
          dispatcher.fireEvent(SlotEventConstants.SCATTER_ANIMATION_ENDED, scatterWinData);
        }, this);
      }
      this.reelPanel.showAllSymbols();
      this.clearSymReels();
    }, (this));
  }

  /**
   * Method Override to start win line animation
   */
  public startWinLineAnimation(evt?: IEvent) {
    this.reelPanel.showAllSymbols();
    super.startWinLineAnimation(evt);
  }

  /**
   * Method overrided to stopstack symbol animation
   */
  protected stopAllWinLineSymbol(): void {
    super.stopAllWinLineSymbol();
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      dispatcher.fireEvent(eventDispatchers.STOP_STACK_SYM_ANIM_FG);
    } else {
      dispatcher.fireEvent(eventDispatchers.STOP_STACK_SYM_ANIM);
    }

  }
  private resetPlaySoundCounter():void{
    this.playCount = 0;
  }

  /**
   * Method overrided to stopstack symbol animation
   */
  protected winCycleCompleted(): void {
    super.winCycleCompleted();
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      dispatcher.fireEvent(eventDispatchers.STOP_STACK_SYM_ANIM_FG);
    } else {
      dispatcher.fireEvent(eventDispatchers.STOP_STACK_SYM_ANIM);
    }
  }

  /**
   * Method showWinLine overided to update functionality
   */
  protected showWinLine(winLineData: any, currentWinLine: any): void {
    super.showWinLine(winLineData, currentWinLine);
    // const winSymbolNumber: number = winLineData[currentWinLine].no
    // this.checkForWinSound(winSymbolNumber);
    // (ingenuity.soundManager as any).playSound(SoundConstantGame.WIN_LINE_SOUND, 1, false, gameConstants.SOUND_LIST_PRELOAD);
    dispatcher.fireEvent(eventDispatchers.STOP_STACK_ANIM_WITH_LINE_WIN, winLineData[currentWinLine].positions);
  }

  /**
   * Method checkForWinSound to check for win sound
   * @param symbolNumber 
   */
  // private checkForWinSound(symbolNumber: number): void {
  //   switch (symbolNumber) {
  //     case 1:
  //       this.playStackWinSound();
  //       break;
  //   }
  // }

  /**
   * Method playStackWinSound to play stack win sound
   */
  // private playStackWinSound(): void {
  //   (ingenuity.soundManager as any).playSound(SoundConstantGame.STACK_WIN, 1, false, gameConstants.SOUND_LIST_PRELOAD);
  // }

  /**
   * Overrided to stop symbol animation when click on any button
   */
  protected stopAllWinAnimations(): void {
    super.stopAllWinAnimations();
    this.stopAllWinLineSymbol();
  }
  protected animateWinLineSymbol(winLineData: IWinLineObject): void {
    const winLineDataLength = this.model.winLineData.length;
    if (this.playCount < winLineDataLength) {
      let soundInstance = (ingenuity.soundManager as AudioControllerBehavior).getSoundInstance(SoundConstantGame.WIN_LINE_SOUND, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
      if (soundInstance) {
        (ingenuity.soundManager as any).stop(SoundConstantGame.WIN_LINE_SOUND, gameConstants.SOUND_LIST_PRELOAD);
      }
    (ingenuity.soundManager as any).playSound(SoundConstantGame.WIN_LINE_SOUND, 1, false, gameConstants.SOUND_LIST_PRELOAD);
      this.playCount++;
    }
    super.animateWinLineSymbol(winLineData);
  }

}
